import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

import Aux from "../../../../hoc/Aux/Aux";
import "./Doradztwo.css";
import imageSection1_1 from "../../../../img/architektura/doradztwo1.JPG";

const images = [imageSection1_1];

export default class Doradztwo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      imagePadding: 100
    };
  }
  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <Aux>
        <div className="card-background row p-5">
          <div className="col-md lead mt-3">
            Kiedy nadszedł czas:
            <ul>
              <li>zmiany wystroju salonu</li>
              <li>wymiany starych mebli w kuchni</li>
              <li>remontu łazienki</li>
              <li>przemalowania pokoju dziecka</li>
              <li>porady, ale jeszcze nie projektu</li>
            </ul>
          </div>
          <div className="col-md lead mt-3">
            Wystarczy doradztwo:
            <ul>
              <li>spotkanie, najczęściej na inwestycji</li>
              <li>rozmowa i inny punkt widzenia </li>
              <li>nowe możliwości, wzorniki i materiały</li>
              <li>niski koszt konsultacji i dojazdu </li>
            </ul>
          </div>
          <div className="row pt-4">
            <div className="image-lightbox col-lg-4 m-auto p-1 border border-dark rounded">
              <img
                src={imageSection1_1}
                alt=""
                className="img-fluid"
                onClick={() => this.setState({ isOpen: true, photoIndex: 0 })}
              />
            </div>
          </div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
      </Aux>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Architecture/Services/Doradztwo/Doradztwo.js